import { useCallback, useState } from "react";
import { useDispatch } from "react-redux";
import { TypedThunkDispatch } from "../../../../../reducers/thunk/type";
import { buildBaseNetworkPayload } from "../../create/hooks/helpers";
import useZoneId from "../../../../../custom-hooks/region/useZoneId";
import { modifyNetwork } from "../../actions";
import { ValidOpenstackResource } from "../../../../types";

const useNetworkModifyAction = ({
  network,
  formData,
}: {
  network?: ValidOpenstackResource;
  formData: { [key: string]: any };
}) => {
  const [isModifying, setIsModifying] = useState(false);
  const zoneId = useZoneId(formData?.region);

  const dispatch: TypedThunkDispatch = useDispatch();

  const modifyAction = useCallback(() => {
    setIsModifying(true);

    const networkPayload = {
      network: buildBaseNetworkPayload(formData, zoneId),
    };

    networkPayload.network.port_security_enabled = Boolean(
      formData.portSecurity,
    );

    dispatch(modifyNetwork(network, networkPayload)).finally(() => {
      setIsModifying(false);
    });
  }, [dispatch, formData, network, zoneId]);

  return {
    modifyAction,
    isModifying,
  };
};

export default useNetworkModifyAction;
